import React from 'react';
import { render } from 'react-dom';
import './styles/layout.less';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ----------------------------------------------------------------------------
// 抑制 "ResizeObserver loop completed with undelivered notifications" 警告
// ----------------------------------------------------------------------------
// 原因：浏览器 ResizeObserver 在同一渲染周期内收到多个尺寸通知时，会打印此警告。
// antd 的 Table/Sider 在 Sider 切换 + 列表数据加载时容易触发，警告本身无害。
// 方案：
//   1. 用 setTimeout(0) 把回调推到下一个 task，彻底打断当前栈的同步循环
//   2. 同一帧内多次 resize 事件合并为一次回调
//   3. 兜底过滤 console.error 中该特定警告的日志
// ----------------------------------------------------------------------------

const originalResizeObserver = window.ResizeObserver;

window.ResizeObserver = class PatchedResizeObserver extends originalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
        let frameId: number | null = null;
        let lastEntries: ResizeObserverEntry[] = [];
        let lastObserver: ResizeObserver | null = null;

        super((entries, observer) => {
            lastEntries = entries;
            lastObserver = observer;
            if (frameId !== null) return;
            // 推到一个独立 task：让当前布局完成后再处理
            frameId = window.setTimeout(() => {
                frameId = null;
                if (lastObserver) {
                    callback(lastEntries, lastObserver);
                }
            }, 0);
        });
    }
};

// 兜底：即使上面没拦住，也不再让这个特定警告刷屏
const _origConsoleError = console.error;
console.error = (...args: any[]) => {
    const msg = args[0];
    if (typeof msg === 'string' && msg.includes('ResizeObserver loop completed with undelivered notifications')) {
        return;
    }
    _origConsoleError(...args);
};



const root = document.getElementById('root') as HTMLElement
render(
    <App />,
    root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
